import { render, staticRenderFns } from "./invoices-table.vue?vue&type=template&id=67d14cfe&scoped=true&"
import script from "./invoices-table.vue?vue&type=script&lang=ts&"
export * from "./invoices-table.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-table.vue?vue&type=style&index=0&id=67d14cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d14cfe",
  null
  
)

export default component.exports